// extracted by mini-css-extract-plugin
export default {"input":"snxwa","wrapper":"iZUiJ","radio":"qHMrQ","label":"_77Dmv"};